module.exports = __webpack_public_path__ + "static/media/muscle.9d35acd0.svg";